import { Component, OnInit } from "@angular/core";
import { ClientUserUriBuilderParams } from "@app/core/services/user.service";
import { AuthenticationMethod } from "@app/shared/models/client-user";
import { User2FAComponentBase } from "./user-2fa";

@Component({
    selector: 'user-2fa-totp',
    templateUrl: './user-2fa-totp.component.html'
})
export class User2FATotpComponent extends User2FAComponentBase implements OnInit {
    
    tan: string;
    qrCode: string;
    secret: string;
    showCodeVerifySection: boolean;

    ngOnInit(): void {
        if (this.user.authentication_method === AuthenticationMethod.TOTP && !this.user.authentication_totp_verified) {
            this.setup();
        }
    }

    public setup() {
        const uriBuilder = new ClientUserUriBuilderParams(this.client, this.user);

        this.tan = '';
        this.qrCode = '';
        this.secret = '';

        this.userService.setupTwoFAWithApp(uriBuilder).subscribe(result=> {
            if (result.status === 'SUCCESS') {
                this.qrCode = result.data.qr_code;
                this.secret = result.data.secret;
            }
        });
    }

    protected resetInternal() {
        this.setup();
    }

    public getQrCode(): string {
        return `data:image/jpeg;base64,${this.qrCode}`;
    }
}
